/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import { PhrMynaLinkStatus, PhrMynaLinkStatusFromJSON, PhrMynaLinkStatusToJSON } from "../models";

export interface GetPatientMynaLinkStatusRequest {
  familyAccountId?: number;
}

/**
 *
 */
export class MynaLinkStatusApi extends runtime.BaseAPI {
  /**
   * Get the patient\'s own myna link status
   */
  async getPatientMynaLinkStatusRaw(
    requestParameters: GetPatientMynaLinkStatusRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PhrMynaLinkStatus>> {
    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/myna-link-status`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PhrMynaLinkStatusFromJSON(jsonValue));
  }

  /**
   * Get the patient\'s own myna link status
   */
  async getPatientMynaLinkStatus(
    requestParameters: GetPatientMynaLinkStatusRequest,
    initOverrides?: RequestInit
  ): Promise<PhrMynaLinkStatus> {
    return promiseRetry(
      (retry) =>
        this.getPatientMynaLinkStatusRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
